'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { useEffect, useState } from 'react';

import { useRouter } from '@infor/ui-lib/routes/hooks';

import { useUser } from 'store/store';

import { paths } from '../routes/paths';

export default function Index() {
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(true);

  const user = useUser.selectors.user();

  const permissoes = useUser.selectors.permissoes();

  const hasHydrated = useUser.selectors.hasHydrated();

  const setHasHydrated = useUser.selectors.setHasHydrated();

  useEffect(() => {
    if (!hasHydrated) return;

    if (!user?.id) {
      router.push(paths.login);

      return;
    }

    if (user.grupoId === '1') {
      router.push(paths.home);

      return;
    }

    if (user?.instrutorId) {
      router.push(paths.agendaAulasPraticas);

      return;
    }

    if (user) {
      router.push(paths.home);

      return;
    }

    setIsLoading(false);
  }, [hasHydrated, permissoes?.isAdmin, router, setHasHydrated, user]);

  if (isLoading)
    return (
      <Stack
        sx={{ height: '100vh', justifyContent: 'center', alignItems: 'center' }}
      >
        <Image
          src="/logo/logo_infor_pequeno2.png"
          alt="Logo"
          width={100}
          height={100}
        />
        <Typography
          variant="body2"
          alignSelf={'center'}
          color={'text.secondary'}
        >
          Carregando dados...
        </Typography>
      </Stack>
    );

  return <></>;
}
